import { clientEnv } from '@nwwp/env/client'
import { type ABSmartlySDKOptions } from '../types'
import { parseABSmartlyEnv } from '../utils/absmartlyEnvParser'
import { ABSMARTLY_APPLICATION_NAME } from '../utils/constants'

export const abSmartlySdkConfig: ABSmartlySDKOptions = {
  endpoint: clientEnv.NEXT_PUBLIC_ABSMARTLY_URL,
  apiKey: clientEnv.NEXT_PUBLIC_ABSMARTLY_API_KEY,
  environment: parseABSmartlyEnv(clientEnv.NEXT_PUBLIC_DEPLOYABLE_ENV ?? 'local'),
  application: ABSMARTLY_APPLICATION_NAME,
}
